var _this = this;
import * as tslib_1 from "tslib";
import getConversationNodeId from 'owa-mail-reading-pane-store/lib/utils/getConversationNodeId';
import isNewestOnBottom from 'owa-mail-reading-pane-store/lib/utils/isNewestOnBottom';
import TableOperations from 'owa-mail-list-table-operations';
import { MailListItemSelectionSource } from 'owa-mail-store';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import { itemPartClicked } from 'owa-mail-actions/lib/mailListSelectionActions';
import { loadConversation, loadItem } from 'owa-mail-store-actions';
import { loadMessageSuggestion } from 'owa-mail-search-actions';
import { orchestrator } from 'satcheljs';
import { removeTableFromStore } from 'owa-mail-list-actions';
import { searchStore } from 'owa-mail-search-store';
import { singleSelectRow } from 'owa-mail-actions';
import { END_MATCH_DELIMITER, START_MATCH_DELIMITER, } from 'owa-mail-search-store/lib/helpers/searchConstants';
import { getTableViewFromTableQuery, loadTableViewFromTableQuery, } from 'owa-mail-table-loading-actions';
orchestrator(loadMessageSuggestion, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var suggestion, listViewType, conversationIdString, cachedConversation, conversationId, itemIds, conversation, cachedItem, itemId, loadedItem;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                suggestion = actionMessage.suggestion;
                listViewType = getSelectedTableView().tableQuery.listViewType;
                if (!(listViewType == 0 /* Conversation */)) return [3 /*break*/, 3];
                conversationIdString = suggestion.ConversationId.Id;
                cachedConversation = getMailStore().conversations.get(conversationIdString);
                if (!!cachedConversation) return [3 /*break*/, 2];
                conversationId = {
                    Id: conversationIdString,
                    mailboxInfo: getCurrentTableMailboxInfo(),
                };
                return [4 /*yield*/, loadConversation(conversationId, 'LoadSearchSuggestionConversation')];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                itemIds = getItemIdsFromConversationItemParts(conversationIdString);
                conversation = {
                    ConversationId: { Id: conversationIdString },
                    ConversationTopic: dehighlightText(suggestion.Subject),
                    GlobalUnreadCount: 0,
                    UnreadCount: 0,
                    GlobalItemIds: itemIds,
                    ItemIds: itemIds,
                    UniqueSenders: [dehighlightText(suggestion.DisplayName)],
                    LastDeliveryTime: suggestion.DateTimeReceived,
                    LastDeliveryOrRenewTime: suggestion.DateTimeReceived,
                    LastModifiedTime: suggestion.DateTimeReceived,
                    InstanceKey: '0',
                };
                loadSearchTableWithMessageSuggestion(conversation, suggestion.ItemId.Id);
                return [3 /*break*/, 8];
            case 3:
                cachedItem = getMailStore().items.get(suggestion.ItemId.Id);
                if (!(cachedItem && cachedItem.NormalizedBody)) return [3 /*break*/, 4];
                loadSearchTableWithMessageSuggestion(cachedItem);
                return [3 /*break*/, 8];
            case 4:
                itemId = {
                    Id: suggestion.ItemId.Id,
                    mailboxInfo: getCurrentTableMailboxInfo(),
                };
                return [4 /*yield*/, loadItem(itemId, 'LoadSearchSuggestionItem')];
            case 5:
                loadedItem = _a.sent();
                if (!!loadedItem) return [3 /*break*/, 7];
                return [4 /*yield*/, loadLatestConversationItem(suggestion.ConversationId.Id)];
            case 6:
                // this handles the scenario where the item has been moved to a different folder and
                // can no longer be found in store, while the suggestion index still contain stale item id
                // fallback to the last item of the conversation instead
                loadedItem = _a.sent();
                _a.label = 7;
            case 7:
                loadSearchTableWithMessageSuggestion(loadedItem);
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}); });
function loadLatestConversationItem(conversationIdString) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var cachedConversation, conversationId, itemId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cachedConversation = getMailStore().conversations.get(conversationIdString);
                    conversationId = {
                        Id: conversationIdString,
                        mailboxInfo: getCurrentTableMailboxInfo(),
                    };
                    if (!!cachedConversation) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadConversation(conversationId, 'LoadSearchSuggestionConversation')];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    itemId = getLatestItemId(conversationId);
                    return [4 /*yield*/, loadItem(itemId, 'LoadSearchSuggestionItem')];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function loadSearchTableWithMessageSuggestion(row, itemPartId) {
    var isOpenEmailSuggestionsInTabEnabled = is3SFeatureEnabled('sea-emailSuggestionsInTab');
    var searchTableQuery = {
        folderId: null,
        type: 1 /* Search */,
        listViewType: getSelectedTableView().tableQuery.listViewType,
        searchNumber: searchStore.searchNumber,
        queryString: searchStore.searchTextForSuggestion,
        searchScope: searchStore.staticSearchScope,
        pillSuggestions: tslib_1.__spread(searchStore.suggestionPills.values()),
        includeAttachments: searchStore.includeAttachments,
        fromDate: searchStore.fromDate,
        toDate: searchStore.toDate,
        scenarioType: 'messageSuggestion',
    };
    var tableView = getTableViewFromTableQuery(searchTableQuery);
    // add the single item into the table
    TableOperations.clear(tableView);
    TableOperations.addRow(0, row, tableView);
    if (!isOpenEmailSuggestionsInTabEnabled) {
        // do not load list view if the email suggestion is being
        // opened in a tab
        loadTableViewFromTableQuery(searchTableQuery, null /* loadTableViewDatapoint */, 'SearchBoxSuggestionDropDown');
    }
    // auto select the first and the only item
    singleSelectRow(tableView, tableView.rowKeys[0], false /* isUserNavigation */, MailListItemSelectionSource.SearchSuggestionClick);
    // itemPartId is only available for conversation view
    // call itemPartClicked to scroll to it
    if (!isOpenEmailSuggestionsInTabEnabled &&
        searchTableQuery.listViewType == 0 /* Conversation */ &&
        itemPartId) {
        var nodeId = getConversationNodeId(row.ConversationId.Id, itemPartId);
        var conversationItemParts = getMailStore().conversations.get(row.ConversationId.Id);
        var conversationNodeIds = conversationItemParts
            ? conversationItemParts.conversationNodeIds
            : [];
        itemPartClicked(nodeId, itemPartId, conversationNodeIds, tableView);
    }
    if (isOpenEmailSuggestionsInTabEnabled) {
        // remove the table view once item is loaded in tab
        // when list view is loaded (emailSuggestionsInTab feature off)
        // table is cleaned up in onAfterTableLoad
        removeTableFromStore(tableView.id);
    }
}
function dehighlightText(text) {
    var START_MATCH_DELIMITER_REGEXP = new RegExp(START_MATCH_DELIMITER, 'g');
    var END_MATCH_DELIMITER_REGEXP = new RegExp(END_MATCH_DELIMITER, 'g');
    return text.replace(START_MATCH_DELIMITER_REGEXP, '').replace(END_MATCH_DELIMITER_REGEXP, '');
}
function getItemIdsFromConversationItemParts(conversationId) {
    var conversationItemParts = getMailStore().conversations.get(conversationId);
    var conversationNodeIds = conversationItemParts
        ? conversationItemParts.conversationNodeIds
        : [];
    var allItemIds = [];
    conversationNodeIds.forEach(function (conversationNodeId) {
        var conversationNode = getMailStore().conversationNodes.get(conversationNodeId);
        var itemIds = conversationNode ? conversationNode.itemIds : [];
        itemIds.forEach(function (id) {
            allItemIds.push({ Id: id });
        });
    });
    return allItemIds;
}
function getLatestItemId(conversationId) {
    var itemIds = getItemIdsFromConversationItemParts(conversationId.Id);
    var index = isNewestOnBottom() ? itemIds.length - 1 : 0;
    return {
        mailboxInfo: conversationId.mailboxInfo,
        Id: itemIds[index].Id,
    };
}
//# sourceMappingURL=loadMessageSuggestionOrchestrator.js.map